import React from "react";
import styled from "styled-components";
import { BarChart } from "@mui/x-charts/BarChart";
import { PieChart } from "@mui/x-charts/PieChart";
import { LineChart } from "@mui/x-charts/LineChart";
import { fonts } from "../../assets/styles/theme.ts";
import { monthMap, months, dataPierChart, colorsPierChart, seriesLineChart, seriesTiempoLineChart, series } from "./Utils.js";
import { colorClear } from "../ClearColor/ColorClear.js";
import Tables from "../Tables/Tables.jsx";



const BarChartComponent = (props) => {

  const renderSeries = () => {
    const defaultData = [
      {
        data: [
          50, 80, 70, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13,
          60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64,
          89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45,
          13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13,
        ],
        color: "#50A449",
        label: "Normal",
      },
      {
        data: [
          50, 80, 70, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13,
          60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64,
          89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45,
          13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13,
        ],
        color: "#dbdb4f",
        label: "Precaución",
      },
      {
        data: [
          50, 80, 70, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13,
          60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64,
          89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45,
          13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13,
        ],
        color: "#E70404",
        label: "Peligro",
      },
      {
        data: [
          50, 80, 70, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13,
          60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64,
          89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45,
          13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13,
        ],
        color: "#3d04e7",
        label: "Estado",
      },
      {
        data: [
          50, 80, 70, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13,
          60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64,
          89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45,
          13, 60, 50, 64, 89, 87, 45, 13, 60, 50, 64, 89, 87, 45, 13,
        ],
        color: "#e76e04",
        label: "Warning",
      },
    ];
    const render =
      props.series?.map((res) => {
        return { data: res.data, color: res.color, label: res.label };
      }) ?? defaultData;

    return render;
  };

  const StyledHome = styled.div`
    display: flex;
    justify-content: center;

    .MuiChartsAxis-directionX {
      .MuiChartsAxis-tick {
        font-weight: bold;
      }
      .MuiChartsAxis-tickLabel {
        transform: rotate(-40deg) translate(-10px, 5%);
        text-anchor: end;

        tspan {
          font-size: 20px;
        }
      }
    }
    .MuiChartsAxis-directionY {
      .MuiChartsAxis-line {
        display: none;
      }
      .MuiChartsAxis-tick {
        display: none;
      }
      .MuiChartsAxis-tickLabel {
        tspan {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
  `;
  const StyledReportesAnalisis = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    .divTable{
      height: 500px;
      overflow-y: auto;
    }
    .MuiChartsAxis-directionY {
      .MuiChartsAxis-line {
        display: none;
      }
      .MuiChartsAxis-tick {
        display: none;
      }
      .MuiChartsAxis-tickLabel {
        /* tspan {
          font-size: 20px;
          font-weight: bold;
        } */
      }
    }
    .MuiBarLabel-root {
      font-weight: bold;
      font-size: 15px;
      padding: 0px 10px;
      font-family: ${fonts.primary};
      fill: white;
    }
    .MuiChartsAxis-tickLabel {
      tspan {
        font-size: 15px;
      }
    }
    .styledTables {
      width: 100%;
      .MuiTableContainer-root{
      width:95% !important;
    }
      height: auto;
      
      th {
        background-color: #b6b4b457;
      }
      .MuiTableCell-root {
        img {
          display: none;
        }
      }
      .MuiTableContainer-root {
        width: 60%;
        margin: auto;
      }
    }
  `;
  const StyledEstado = styled.div`
    display: flex;
    justify-content: center;
    .MuiChartsAxis-directionX {
      .MuiChartsAxis-tick {
        font-weight: bold;
      }
      .MuiChartsAxis-tickLabel {
        tspan {
          font-size: 15px;
        }
      }
    }
    .MuiChartsAxis-directionY {
      .MuiChartsAxis-line {
        display: none;
      }
      .MuiChartsAxis-tick {
        display: none;
      }
      .MuiChartsAxis-tickLabel {
        tspan {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
  `;
  const StyledDiagnostico = styled.div`
    display: flex;
    justify-content: center;
    .MuiChartsAxis-directionX {
      .MuiChartsAxis-tick {
        font-weight: bold;
      }
      .MuiChartsAxis-tickLabel {
        tspan {
          font-size: 15px;
        }
      }
    }
    .MuiChartsAxis-directionY {
      .MuiChartsAxis-line {
        display: none;
      }
      .MuiChartsAxis-tick {
        display: none;
      }
      .MuiChartsAxis-tickLabel {
        tspan {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
  `;
  const StyledReportesCausasDeFalla = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;

    .MuiPieArcLabel-root {
      font-weight: bold;
      font-size: 20px;
      font-family: ${fonts.primary};
      fill: #000000;
    }

    .customLegend {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 5px;
    }

    .legendItem {
      display: flex;
      align-items: center;
      gap: 5px;
      font-family: ${fonts.primary};
      font-size: 18px;
      color: #333;
    }
    .legendColor {
      width: 16px;
      height: 16px;
      border-radius: 2px;
    }
  `;
  const StyledReportesDemoras = styled.div`
    display: flex;
    justify-content: center;
    .MuiChartsAxis-directionX {
      .MuiChartsAxis-tick {
        font-weight: bold;
      }
      /* .MuiChartsAxis-tickLabel {
        text-anchor: end;
        tspan {
          font-size: 20px;
        }
      } */
    }

    .MuiChartsAxis-directionY {
      .MuiChartsAxis-line {
        display: none;
      }
      .MuiChartsAxis-tickContainer {
        display: none;
      }
      .MuiChartsAxis-tick {
        display: none;
      }
      .MuiChartsAxis-tickLabel {
        tspan {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
    .MuiBarLabel-root {
      font-weight: bold;
      font-size: 25px;
      font-family: ${fonts.primary};
      fill: white;
    }
  `;
  const StyledReportesTiempo = styled.div`
    .styledTables {
      th {
        background-color: #b6b4b457;
      }
      .MuiTableCell-root {
        img {
          display: none;
        }
      }
    }
  `;
  const StyledReportesCambios = styled.div`
    .styledTables {
      th {
        background-color: #b6b4b457;
      }
      .MuiTableCell-root {
        img {
          display: none;
        }
      }
    }
  `;


  const renderBarchart = () => {
    const sizeFallas = {
      width: 800,
      height: 1000,
    };
    const formatearFechas = Array.isArray(props?.footerLabel)
      ? props.footerLabel.map((item) => {
        if (typeof item !== 'string') return '';

        const [mes, anio] = item.split(' ');
        const numeroMes = monthMap?.[mes];


        if (!numeroMes || !anio) return '';

        return `${numeroMes}/${anio}`;
      })
      : [];


    const formatearFechasLineChart = Array.isArray(props?.series)
      ? props.series.map((item) => {
        if (typeof item !== 'string') return '';

        const [mes, anio] = item.split(" ");
        const numeroMes = monthMap?.[mes];


        if (!numeroMes || !anio) return '';

        return `${numeroMes}/${anio}`;
      })
      : [];

    let coloredDataPierChart = [];
    if (props.type === "fallas") {
      coloredDataPierChart = props.series?.data.map((item, index) => {
        const color = colorsPierChart[index % colorsPierChart.length];
        return {
          ...item,
          color,
          textColor: colorClear(color) ? "#FFFFFF" : "#000000",
        };
      });
    } else {
      coloredDataPierChart = props.series?.map((item, index) => {
        const color = colorsPierChart[index % colorsPierChart.length];
        return {
          ...item,
          color,
          textColor: colorClear(color) ? "#FFFFFF" : "#000000",
        };
      });
    }

    switch (props.type) {
      // analisis = Demora promedio por conjunto de análisis
      // estado = Cantidad de muestras por estado
      // diagnostico = Cantidad de muestras por estado de diagnóstico
      // fallas = Causas de fallas
      // demoras = Días de demora por órden de trabajo
      // tiempo = Tiempo medio entre fallas
      // cambios = Línea de cambios de estados
      case "analisis":
        return (
          <StyledReportesAnalisis style={{
            width:
              props.footerLabel?.length > 24
                ? "10000px"
                : props.footerLabel?.length > 12
                  ? "2000px"
                  : "auto",
          
          }}>
            <BarChart
              xAxis={[
                {
                  scaleType: "band",
                  data: props.footerLabel ?? [],
                },
              ]}
              yAxis={[
                {
                  min: 0,
                  max: (() => {
                    const values = props.series?.map((item) => {
                      const num = Number(item.value);
                      return isNaN(num) ? 0 : num;
                    }) ?? [0];
                    const maxValue = Math.max(...values);
                    return maxValue > 0 ? maxValue * 1.1 : 100; // Si maxValue es 0, usar 100 como fallback
                  })(),
                },
              ]}
              sx={{
                "& .MuiBarElement-root:nth-of-type(1)": {
                  fill: "#1316b9",
                },
                "& .MuiBarElement-root:nth-of-type(2)": {
                  fill: "#f38004",
                },
              }}
              grid={{ horizontal: true }}
              height={props.height ?? 500}
              series={[
                {
                  data: props.series?.map((item) => {
                    const num = Number(item?.value);
                    return isNaN(num) ? 0 : parseFloat(num.toFixed(2));
                  }) ?? [],
                  baseline: 0,
                },
              ]}
              barLabel={"value"}

            />
            <div className="divTable">
              {props.rows &&
                props.rows.map((row, index) => (

                  <Tables
                    key={index} // Siempre es importante usar una key única para cada componente en listas
                    typeTable={"prop"}
                    columns={props.columns && props.columns}
                    rows={row} // Cada "row" será un subarray de datos
                    cRows={20}
                    caption={props.caption}
                    labelCaption={props.labelCaption && props.labelCaption[index]} // Asigna la etiqueta según el índice
                    pagination={false}
                  />

                ))}
            </div>
          </StyledReportesAnalisis>
        );
      case "estado":
        return (
          <StyledEstado
            style={{
              width: props.footerLabel?.length > 24 ? "10000px" : "auto",
            }}
          >
            <BarChart
              slotProps={{
                legend: {
                  direction: "row",
                  position: {
                    vertical: "top",
                    horizontal:
                      props.footerLabel?.length > 24 ? "left" : "center",
                  },
                  labelStyle: {
                    fontSize: 25,
                    padding: 5,
                  },
                  padding: 0,
                },
              }}
              xAxis={[{ scaleType: "band", data: formatearFechas ?? [] }]}
              yAxis={[
                {
                  min: 0,
                  max: Math.max(...props.series.flatMap(series => series.data)),
                  line: { display: false },
                }
              ]}
              height={props.height ?? 500}
              series={renderSeries()}
              grid={props.grid ?? { horizontal: true }}
            />
          </StyledEstado>
        );
      case "diagnostico":
        return (
          <StyledDiagnostico
            style={{
              width: props.footerLabel?.length > 24 ? "10000px" : "auto",
            }}
          >
            <BarChart
              slotProps={{
                legend: {
                  direction: "row",
                  position: {
                    vertical: "top",
                    horizontal:
                      props.footerLabel?.length > 24 ? "left" : "center",
                  },
                  labelStyle: {
                    fontSize: 25,
                    padding: 5,
                  },
                  padding: 0,
                },
              }}
              xAxis={[{ scaleType: "band", data: formatearFechas ?? [] }]}
              yAxis={[
                {
                  min: 0,
                  max: Math.max(...props.series.flatMap(series => series.data)),
                  line: { display: false },
                }
              ]}
              height={props.height ?? 500}
              series={renderSeries()}
              grid={props.grid ?? { horizontal: true }}
            />
          </StyledDiagnostico>
        );
      case "fallas":
        return (
          <StyledReportesCausasDeFalla>
            {console.log(props.series)}

            <PieChart
              series={[
                {
                  data: coloredDataPierChart ?? [],
                  arcLabel: (item) => `${item.value}%`,
                  arcLabelMinAngle: 10,
                  arcLabelRadius: "70%",
                },
              ]}
              slotProps={{
                tooltip: {
                  formatter: (item) => `${item.label}: ${item.value}%`,
                },
                legend: {
                  hidden: true,
                },
              }}
              width={600}
              // height={400}
              {...sizeFallas}
            />

            <div className="customLegend">
              {coloredDataPierChart.map((item, index) => (
                <div className="legendItem" key={index}>
                  <div
                    className="legendColor"
                    style={{ backgroundColor: item.color }}
                  />
                  <p>{item.label}</p>
                </div>
              ))}
            </div>

          </StyledReportesCausasDeFalla>
        );
      case "demoras":


        return (
          <StyledReportesDemoras>
            <BarChart
              xAxis={[
                {
                  scaleType: "band",
                  data: props.series?.map((item) => item.label) ?? [],
                },
              ]}
              series={[
                {
                  data: props.series?.map((item) => item.value) ?? [],
                },
              ]}
              sx={{
                "& .MuiBarElement-root": {
                  fill: "#1316b9",
                },
              }}
              grid={{ horizontal: true }}
              height={props.height ?? 500}
              barLabel="value"
            />
          </StyledReportesDemoras>
        );
      case "tiempo":
        return (

          <StyledReportesTiempo>
            <LineChart
              yAxis={[
                {
                  min: 0,

                  max: (() => {
                    const m = props.seriesTiempo?.flat?.().reduce((max, num) => (typeof num === 'number' && num > max ? num : max), -Infinity);
                    return isFinite(m) ? m : 100;
                  })(),

                  line: { display: true },
                  colorMap: {
                    type: "piecewise",
                    thresholds: [0, 10],
                    colors: ["#3364ed", "#3364ed", "#3364ed"],
                  },
                },
              ]}
              xAxis={[
                //props.series
                //seriesLineChart
                //formatearFechasLineChart
                {
                  data: formatearFechasLineChart,
                  scaleType: "band",
                },
              ]}
              grid={{ horizontal: true }}
              //props.seriesTiempo[0]
              //seriesTiempoLineChart
              series={[{ data: props.seriesTiempo[0] }]}
              height={400}
            />
            <Tables
              typeTable={"prop"}
              columns={props.columns && props.columns}
              rows={props.rows && props.rows}
              cRows={20}
              pagination={false}
            />
          </StyledReportesTiempo>
        );
      case "cambios":
        return (
          <Tables
            typeTable={"prop"}
            columns={props.columns && props.columns}
            rows={props.rows && props.rows}
            cRows={20}
            // totalRows={itemsCount}
            // actualpage={paginaActual}
            pagination={false}
          // page={(e) => setPaginaActual(e + 1)}
          // pages={pageCount}
          />
        );

      default:
        return (
          <StyledHome>
            <BarChart
              slotProps={{
                legend: {
                  direction: "row",
                  position: { vertical: "top", horizontal: "middle" },
                  labelStyle: {
                    fontSize: 25,
                    padding: 5,
                  },
                  padding: 0,
                },
              }}
              xAxis={[{ scaleType: "band", data: props.footerLabel ?? months }]}
              yAxis={[
                {
                  min: 0,
                  max: Math.max(...props.series.flatMap(series => series.data)),
                  line: { display: false },
                }
              ]}
              series={renderSeries()}
              width={props.width ?? 1000}
              height={props.height ?? 500}
              grid={props.grid ?? { horizontal: true }}
            />
          </StyledHome>
        );
    }
  };

  // return props.series?.data?.length > 0 ? <>{renderBarchart()}</> :
  //   <p
  //     style={{ fontFamily: fonts.primary, fontSize: "20px", textAlign: "center", width: "96%" }}>
  //     No hay datos
  //   </p >;
  return <>{renderBarchart()}</>
};

export default BarChartComponent;
// analisis = Demora promedio por conjunto de análisis
// estado = Cantidad de muestras por estado
// diagnostico = Cantidad de muestras por estado de diagnóstico
// fallas = Causas de fallas
// demoras = Días de demora por órden de trabajo
// tiempo = Tiempo medio entre fallas
// cambios = Línea de cambios de estados
